import React from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useHistory } from 'react-router-dom';
import { PlusCircleFilled } from '@ant-design/icons';

import { Title } from '@/components/Typography';
import { BERA_REPORT_PATH } from '@/views/Bera/constants';

import * as S from './styles';

export function Header(): JSX.Element {
	const history = useHistory();

	function handleCreateReport() {
		history.push(BERA_REPORT_PATH);
	}

	return (
		<Row justify="space-between">
			<Col>
				<Title level={4}>Basic Ergonomics Risk Assessment (B.E.R.A.)</Title>
			</Col>
			<Col span={0.1}>
				<S.CreateButton type="primary" icon={<PlusCircleFilled />} onClick={handleCreateReport}>
					{I18n.get('New Report')}
				</S.CreateButton>
			</Col>
		</Row>
	);
}
